var _path, _path2, _path3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 9.73505L9.8 9.93006C9.615 9.97506 9.47 10.1151 9.43 10.3001L9.255 11.0351C9.16 11.4351 8.65 11.5601 8.385 11.2451L6.89 9.52505C6.77 9.38505 6.835 9.16505 7.015 9.12005C7.9 8.90505 8.695 8.41005 9.28 7.70506C9.375 7.59006 9.545 7.57505 9.65 7.68005L10.76 8.79006C11.14 9.17006 11.005 9.64505 10.625 9.73505Z",
    fill: "#FF7320"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34999 9.73505L2.17499 9.93006C2.35999 9.97506 2.50499 10.1151 2.54499 10.3001L2.71999 11.0351C2.81499 11.4351 3.32499 11.5601 3.58999 11.2451L5.08499 9.52505C5.20499 9.38505 5.13999 9.16505 4.95999 9.12005C4.07499 8.90505 3.27999 8.41005 2.69499 7.70506C2.59999 7.59006 2.42999 7.57505 2.32499 7.68005L1.21499 8.79006C0.83499 9.17006 0.96999 9.64505 1.34999 9.73505Z",
    fill: "#FF7320"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5C4.065 1.5 2.5 3.065 2.5 5C2.5 5.725 2.715 6.39 3.085 6.945C3.625 7.745 4.48 8.31 5.475 8.455C5.645 8.485 5.82 8.5 6 8.5C6.18 8.5 6.355 8.485 6.525 8.455C7.52 8.31 8.375 7.745 8.915 6.945C9.285 6.39 9.5 5.725 9.5 5C9.5 3.065 7.935 1.5 6 1.5ZM7.53 4.89L7.115 5.305C7.045 5.375 7.005 5.51 7.03 5.61L7.15 6.125C7.245 6.53 7.03 6.69 6.67 6.475L6.17 6.18C6.08 6.125 5.93 6.125 5.84 6.18L5.34 6.475C4.98 6.685 4.765 6.53 4.86 6.125L4.98 5.61C5 5.515 4.965 5.375 4.895 5.305L4.47 4.89C4.225 4.645 4.305 4.4 4.645 4.345L5.18 4.255C5.27 4.24 5.375 4.16 5.415 4.08L5.71 3.49C5.87 3.17 6.13 3.17 6.29 3.49L6.585 4.08C6.625 4.16 6.73 4.24 6.825 4.255L7.36 4.345C7.695 4.4 7.775 4.645 7.53 4.89Z",
    fill: "#FF7320"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.991bd412.svg";
export { ForwardRef as ReactComponent };